import React, { HTMLProps } from "react";
import "./styles.scss";

interface SubtitleProps extends HTMLProps<HTMLHeadingElement> {
  text: string;
}

const Subtitle = ({ text }: SubtitleProps) => (
  <h2 className="subtitle">{text}</h2>
);

export { Subtitle };
